/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { Navigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { ROLES } from './redux/auth/auth.actions';

export default function PrivateRoute({ component: Component, roles }) {
  async function checkAuthState() {
    try {
      await Auth.currentAuthenticatedUser();
    } catch (err) {
      console.error(err);
    }
  }
  useEffect(() => {
    checkAuthState();
  });
  const isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  };

  const isAuthenticated = localStorage.getItem('isAuthenticated');
  const userProfile = localStorage.getItem('userProfile');
  const jwtToken = localStorage.getItem('jwtToken');

  const hasRole = userProfile && userProfile === roles;
  // console.log('roles', roles);
  // console.log('userProfile', userProfile);
  // console.log('isAuthenticated', isAuthenticated);
  // console.log('jwtToken', isValidToken(jwtToken));
  // console.log('hasRole', hasRole);

  if (isValidToken(jwtToken) && isAuthenticated && hasRole) {
    return <Component />;
  }


  //  CLIENT
  if (isValidToken(jwtToken) && isAuthenticated && !hasRole && roles === ROLES.CLIENT) {
    return <Navigate to="/401" />;
  }

  if (isAuthenticated && !hasRole && roles === ROLES.CLIENT) {
    return <Navigate to="/401" />;
  }

  if (isAuthenticated && !isValidToken(jwtToken) && roles === ROLES.CLIENT) {
    return <Navigate to="/405" />;
  }

  //  ADMIN

  if (isValidToken(jwtToken) && isAuthenticated && !hasRole && roles === ROLES.ADMIN) {
    return <Navigate to="/401-admin" />;
  }

  if (isAuthenticated && !hasRole && roles === ROLES.ADMIN) {
    return <Navigate to="/401-admin" />;
  }

  if (isAuthenticated && !isValidToken(jwtToken) && roles === ROLES.ADMIN) {
    return <Navigate to="/405-admin" />;
  }



  if (roles === ROLES.ADMIN) {
    return <Navigate to="/admin" />;
  }

  return <Navigate to="/login" />;
}
